import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { userResponse } from "../../classes/userResponse/user-response";
import { HttpErrorsService } from "../alerts/errors/http-errors.service";
import { ConectarApiService } from "../api/connection/conectar-api.service";
import { MsalService } from "@azure/msal-angular";
import { environment } from "src/environments/environment";
import { ILoginUserMicrosoftResponse } from "../api/connection/conectar-api.interface";
import {
	ICurrentUser,
	IDatosResultCurrentUser,
	NombreApp,
	Permiso,
} from "./authentication.interface";

@Injectable({
	providedIn: "root",
})
export class AuthenticationService {
	constructor(
		private servicioAPI: ConectarApiService,
		private httpErrorService: HttpErrorsService,
		private router: Router,
		private authService: MsalService, 
	) {}
	
	login(usuario: userResponse) {
		sessionStorage.setItem("currentUser", JSON.stringify(usuario));
	}

	convertUserMicrosoftToUserResponse(usuario: ILoginUserMicrosoftResponse): ICurrentUser {

		let permisosParsed: Permiso[] = [];
	
		if (usuario?.datosResult?.permisos && usuario?.datosResult?.permisos.length > 0) {
			permisosParsed = usuario.datosResult.permisos.map((permiso) => {
				return {
					AccionId: permiso.accionId,
					NombreAccion: permiso.nombreAccion,
					CodigoAccion: permiso.codigoAccion,
					ModuloId: permiso.moduloId,
					CodigoModulo: permiso.codigoModulo,
					NombreModulo: permiso.nombreModulo,
					Ventana: permiso.ventana,
					ModuloIdPadre: permiso.moduloIdPadre,
					NombreApp: NombreApp.Customan,
					NombreIdioma: permiso.nombreIdioma,
					NombreModuloIdioma: permiso.nombreModuloIdioma
				};
			});
		}

		const datosResult: IDatosResultCurrentUser = {
			Id: usuario.datosResult.id,
			NombreUsuario: usuario.datosResult.nombreUsuario,
			Nombre: usuario.datosResult.nombre,
			DeBaja: usuario.datosResult.deBaja,
			Permisos: permisosParsed,
			UltimaFechaAcceso: usuario.datosResult.ultimaFechaAcceso,
			Descripcion: usuario.datosResult.descripcion,
			Privilegios: usuario.datosResult.privilegios,
			TipoUsuarioId: usuario.datosResult.tipoUsuarioId,
			Conectado: usuario.datosResult.conectado,
			CodEmpleado: usuario.datosResult.codEmpleado,
			Token: '',
			CentrosNombres: usuario.datosResult.centrosNombres,
		}

		const currentUser: ICurrentUser = {
			DatosResult: datosResult,
			Mensajes: usuario.mensajes || [],
			LoginDatos: null, // Asumiendo que LoginDatos no se usa en este contexto
		}

		return currentUser;
	}

	logout() {
		// quitar usuario del sessionStorage para desloguearse
		this.servicioAPI.logOut().subscribe((o) => {
			if (o.Mensajes.length === 0) {
				sessionStorage.removeItem("currentUser");
				localStorage.removeItem("tokenMicroservice");
				localStorage.removeItem("microserviceData");
				
				if (
					this.getConfig("HAS_LOGIN_MICROSOFT") &&
					this.authService.instance.getActiveAccount()
				) {
					this.authService.logoutRedirect();
				} else {
					this.router.navigate(["/login"]);
				}

				// this.router.navigate(["/login"]);
			}
		});
	}

	getConfig(param) {
		return environment[param] || null;
	}

	verificar(): boolean {
		if (sessionStorage.getItem("currentUser") != null) {
			return true;
		} else {
			return false;
		}
	}

	ocultarMenusQueryString(_ruta: ActivatedRoute): boolean {
		this.verificarAccesoQueryString(_ruta);
		if (
			_ruta.snapshot.queryParamMap.get("SM") !== null &&
			_ruta.snapshot.queryParamMap.get("SM") === "1"
		) {
			sessionStorage.setItem("OcultarMenu", "true");
			return true;
		} else {
			if (
				sessionStorage.getItem("OcultarMenu") != null &&
				sessionStorage.getItem("OcultarMenu") == "true"
			) {
				if (
					_ruta.snapshot.queryParamMap.get("SM") !== null &&
					_ruta.snapshot.queryParamMap.get("SM") !== "1"
				) {
					sessionStorage.setItem("OcultarMenu", "false");
					return false;
				} else {
					return true;
				}
			} else {
				return false;
			}
		}
	}

	//Parametros aceptados en la ruta:
	//  SM (=1) Sin Menu Lateral (ocultarMenu)
	//  US Usuario
	//  PW Paswword (encriptada TODO)
	async verificarAccesoQueryString(_ruta: ActivatedRoute) {
		if (_ruta !== null) {
			let _usuario = _ruta.snapshot.queryParamMap.get("US");
			let _pwd = _ruta.snapshot.queryParamMap.get("PW");
			let _usuarioO: userResponse;
			if (_usuario !== null && _pwd !== null) {
				// COMPROBAR QUE EL USUARIO SEA DIFERENTE del de memoria o el de memoria sea null,
				if (sessionStorage.getItem("currentUser") == null) {
					//esta llamada ha de ser asincrona, esperamos a que acabe por eso la pasamos a una funcion async
					await this.verificarAccesologinAPI(_usuario, _pwd);
				} else {
					_usuarioO = new userResponse().deserialize(
						JSON.parse(sessionStorage.getItem("currentUser"))
					);
					if (_usuarioO.DatosResult.NombreUsuario.trim() != _usuario.trim()) {
						//esta llamada ha de ser asincrona, esperamos a que acabe por eso la pasamos a una funcion async
						await this.verificarAccesologinAPI(_usuario, _pwd);
					}
				}
			}
		}
	}

	async verificarAccesologinAPI(usuario: string, pwd: string) {
		await this.servicioAPI.getUsuarioAsync(usuario, pwd).then(
			(data) => {
				let usuarioenSession = new userResponse().deserialize(data);
				if (
					usuarioenSession.DatosResult != null &&
					usuarioenSession.DatosResult.DeBaja.toLowerCase() == "false"
				) {
					this.login(usuarioenSession);
				} else {
					//this.alertaServicio.error('No se ha iniciado sesión correctamente o tu cuenta está deshabilitada temporalmente.');
				}
			},
			(error) => {
				//this.alertaServicio.error(error);
				this.httpErrorService.identificarErrores(error);
			}
		);
	}

	getPermisosComoBotones(): Array<any> {
		if (sessionStorage.getItem("currentUser") != null) {
			var permisos = new userResponse().deserialize(
				JSON.parse(sessionStorage.getItem("currentUser"))
			).DatosResult.Permisos;
			if (permisos.length > 0) {
				// Metemos los permisos en hijos y padres seleccionados por VER
				var permisosbotonespadre = permisos.filter(
					(x) =>
						x.NombreAccion.trim().toUpperCase() == "VER" && x.ModuloIdPadre == 0
				);
				var permisosbotoneshijos = permisos.filter(
					(x) =>
						x.NombreAccion.trim().toUpperCase() == "VER" && x.ModuloIdPadre != 0
				);
				// Taxonomía (232) deve aparecer antes de Tipos de Abonado (228) no sidemenu
				const orderModulosRaiz: Record<number, number> = { 232: 0, 228: 1 };
				const padresOrdenados = [...permisosbotonespadre].sort((a, b) => {
					const orderA = orderModulosRaiz[a.ModuloId] ?? 999;
					const orderB = orderModulosRaiz[b.ModuloId] ?? 999;
					return orderA - orderB;
				});
				const normalizeRouteForAngular = (ventana: string): string => {
					if (!ventana) return ventana;
					const v = (ventana || "").trim().toLowerCase();
					if (v === "/taxonomia/centrocostetx") return "/Taxonomia/CentroCosteTX";
					if (v === "/taxonomia/tipopreciotx") return "/Taxonomia/TipoPrecioTX";
					if (v === "/taxonomia/canalventatx") return "/Taxonomia/CanalVentaTX";
					if (v === "/taxonomia/canalventatx") return "/Taxonomia/CanalVentaTX";
					if (v === "/taxonomia/alojamientotx") return "/Taxonomia/AlojamientoTX";
					if (v === "/taxonomia/asociartx") return "/Taxonomia/AsociarTX";
					return ventana;
				};
				const taxonomiaAppConfig = localStorage.getItem("Taxonomia");
				return padresOrdenados.map(function (x) {

          // Ordem customizada para a secção TARIFAS (ModuloIdPadre 125): Grupos Internet -> Temporada Tarifas -> Tarifas
          const tarifasOrderMap: Record<string, number> = {
            "/Tarifas/GruposInternet": 1,
            "/Tarifas/TemporadaTarifas": 2,
            "/Tarifas/Tarifa": 3,
          };

          const getSortOrder = (route: string, moduloIdPadre: number) => {
            if (moduloIdPadre == 125 && tarifasOrderMap[route] != null) {
              return tarifasOrderMap[route];
            }
            return 999;
          };

          const permisosbotoneshijosOrdenado = permisosbotoneshijos
            .filter((y) => y.ModuloIdPadre == x.ModuloId)
            .map(function (z) {
              // Usar NombreModuloIdioma se disponível, caso contrário usar NombreModulo
              const nombreTexto = (z.NombreModuloIdioma && z.NombreModuloIdioma.trim() !== "") 
                ? z.NombreModuloIdioma 
                : (z.NombreModulo || "");
              const routeNormalized = normalizeRouteForAngular(z.Ventana);
              return {
                id: z.AccionId.toString(),
                texto: nombreTexto,
                icono: z.IconModulo,
                route: routeNormalized,
                _sortOrder: getSortOrder(routeNormalized || "", x.ModuloId),
              };
            })
            .filter((entry) => {
              if (taxonomiaAppConfig !== "1" && entry.route === "/Taxonomia/AsociarTX") {
                return false;
              }
              return true;
            })
            .sort((a, b) => {
              if (a._sortOrder !== 999 || b._sortOrder !== 999) {
                return a._sortOrder - b._sortOrder;
              }
              if (a.id > b.id) {
                return 1;
              }
              if (a.id < b.id) {
                return -1;
              }
              return 0;
            })
            .map(({ _sortOrder, ...rest }) => rest);

          // Usar NombreModuloIdioma se disponível, caso contrário usar NombreModulo
          const nombreTextoPadre = (x.NombreModuloIdioma && x.NombreModuloIdioma.trim() !== "") 
            ? x.NombreModuloIdioma 
            : (x.NombreModulo || "");

					return {
						id: x.AccionId.toString(),
						texto: nombreTextoPadre,
						icono: x.IconModulo,
						/* submenu: permisosbotoneshijos
							.filter((y) => y.ModuloIdPadre == x.ModuloId)
							.map(function (z) {
								return {
									id: z.AccionId.toString(),
									texto: z.NombreModuloIdioma,
									icono: z.IconModulo,
									route: z.Ventana,
								};
							}), */
            submenu: permisosbotoneshijosOrdenado,
					};
				});
			} else {
				return [];
			}
		} else {
			return [];
		}
	}
	visualizacionAccion(ruta: string, accion: string): boolean {
		if (sessionStorage.getItem("currentUser") != null) {
			var permisos = new userResponse().deserialize(
				JSON.parse(sessionStorage.getItem("currentUser"))
			).DatosResult.Permisos;
			if (permisos.length > 0) {
				const rutaNorm = (ruta || "").trim().toLowerCase();
				var permisosboton = permisos.filter(
					(x) =>
						x.NombreAccion.trim().toUpperCase() == accion &&
						(x.Ventana || "").trim().toLowerCase() === rutaNorm
				);
				if (permisosboton.length > 0) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		} else {
			return false;
		}
	}
}
